import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getLTSimulationDataEndpoint } from '../../../common/endpoints';

export const getInventoryImpactSimulationData = createApi(getLTSimulationDataEndpoint, 'GET');

const InventoryImpactSimulation = createSlice({
  name: 'InventoryImpactSimulation',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInventoryImpactSimulationData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInventoryImpactSimulationData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getInventoryImpactSimulationData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default InventoryImpactSimulation.reducer;